<template>
  <div class="container">
      <div class="row">
        <div class="col-md-12 my-4">
          <div class="card border-0">
            <div class="card-body">
              <h3 style="color:#4370c2;">Determine Privacy Risks and Overhead Associated With Your Enterprise Data</h3>
              <div class="row mt-4">
                <h4 style="color:#4370c2;">1. Privacy risks associated with your structured data store</h4>
                <div class="col-md-8">
                  <!-- <h4 style="color:#4370c2;" class="my-2">Find out the amount of privacy risk associated with your data store</h4> -->
                  <div class="my-4 row">
                    <label for="staticEmail" class="col-sm-6 col-form-label">Size of your data store*<br><small>(in TB)</small></label>
                    <div class="col-sm-6">
                      <input type="text" required  class="form-control shadow-none border-custom rounded-0" v-model="dataSize">
                    </div>
                  </div>
                  <div class="mb-3 row">
                    <label for="staticEmail" class="col-sm-6 col-form-label">Number of Employees<br><small>(enter a whole number)</small></label>
                    <div class="col-sm-6">
                      <input type="text" required class="form-control shadow-none border-custom rounded-0" v-model="nemployee">
                    </div>
                  </div>
                  <small>* Refers to your structured data store (e.g. Snowflake, Databricks, etc.)</small>
                </div>
                <div class="col-md-4">
                  <center>
                    <h4>Your Potential Privacy Risk</h4>
                  </center>
                  <center class="mt-4">
                    <div class="chart">
                    <div class="bar-9"><span class="my-2" style="color:#1c99a1;">${{Math.round(TotalPrivacyRisk).toLocaleString()}}</span></div>           
                  </div> 
                  </center>
                  <small>
                    Based on the information you provided, you are sitting on <b>${{Math.round(TotalPrivacyRisk).toLocaleString()}}</b> in privacy-related risks
                  </small>
                </div>
              </div>
              <hr class="custom-hr">
              <div class="row mt-4">
                <h4 style="color:#4370c2;">2. Annual overhead costs associated with maintaining data privacy</h4>
                <div class="col-md-8">
                  <!-- <h4 style="color:#4370c2;" class="my-2">Find out the annual overhead costs associated with maintaining the privacy of your stored data </h4> -->
                  <div class="my-4 row">
                    <label for="staticEmail" class="col-sm-6 col-form-label">Frequency of audit<br><small>(enter the number of times you to need to perform data audit in a year)</small></label>
                    <div class="col-sm-6">
                      <input type="text" required class="form-control shadow-none border-custom rounded-0" v-model="frequncyAnnualAudit">
                    </div>
                  </div>
                  <button type="submit" class="btn btn-custom" @click="calculate()">Calculate</button>
                </div>
                <div class="col-md-4">
                  <h4>Your Data Privacy Overhead Costs</h4>
                  <center class="mt-4">
                    <div class="chart chart2">
                    <div class="bar-2"><span class="my-2" style="color:#1c99a1;">${{Math.round(TotalAnnualPrivacyOverheadCosts).toLocaleString()}}</span></div>           
                  </div> 
                  </center>
                  <small>
                    Based on the information you provided, you are looking at <b>${{Math.round(TotalAnnualPrivacyOverheadCosts).toLocaleString()}}</b> in annual privacy-related overhead costs
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      dataSize: 500000,
      nemployee: 100,
      frequncyAnnualAudit: 12,
      TotalPrivacyRisk:'',
      TotalAnnualPrivacyOverheadCosts:''
    }
  },
  methods: {
    calculate: function () {
      var dataSize = this.dataSize;
      var nemployee = this.nemployee;
      var frequncyAnnualAudit = this.frequncyAnnualAudit;

      var A = (6097560796 / 276) * dataSize;
      var B = A*0.001;
      var C = A*0.01;
      var PIIImpact = 36.25*Math.pow(B*Math.pow(10 , -6) , 0.583);
      var PIImpact = 36.25*Math.pow(C*Math.pow(10 , -6) , 0.583)*0.1;
      var TotalImpact  = (PIIImpact + PIImpact)*Math.pow(10 , 6);
      var Multiplier = (1.046 * Math.pow(nemployee , 0.1675))/4.62;
      var TotalPrivacyRisk = TotalImpact * Multiplier;

      var TotalAnnualPrivacyOverheadCosts = ((dataSize * 720000)/(40))*frequncyAnnualAudit;

      this.TotalPrivacyRisk = TotalPrivacyRisk;
      this.TotalAnnualPrivacyOverheadCosts = TotalAnnualPrivacyOverheadCosts;

    }
  },
  mounted () {
    this.calculate();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.border-custom {
  border: 1px solid #4370c2;
}
.custom-hr {
  border: 2px solid #4370c2;
  opacity: 1;
}
.chart {
  height: 130px;
  width: 100px;
  background: #fff;
}
.chart2 {
  height: 70px;
  width: 100px;
  background: #fff;
}
[class*="bar"] {
  border-radius: 0;
  transition: all .6s ease;
  background-color: #ffd851;
  border-top:1px solid transparent;
  border-right:1px solid transparent;
  border-left:1px solid transparent;
  border-bottom:1px solid grey;
  grid-row-start: 1;
  box-sizing: border-box;
  grid-row-end: 101;
  text-align: center;

  margin-top: auto;
  }
[class*="bar"] span{
  position: relative;
  top: -25px;
  color: inherit;
  font-size: 12px;
  font-weight: bold;
}
[class*="bar"] label{
  border-top:3px solid inherit;
  position: absolute;
  width: auto;
  bottom: -23px;
  color: inherit;
  font-size: 12px;
  font-weight: bold;
  margin: auto;

  left: 0;
  right: 0;
}

.lable{
  background-color: #fff;
  text-align: center
}
.lable span{
  background-color: #EAF6FD;
  border:1px solid inherit;
  padding: 0px 20px;
  margin-right: 10px;
}
.bar-9{
  position: relative;
  height:90.034482758621%
}
.bar-2{
  position: relative;
  height:90.034482758621%;
  background-color: #1c99a1;
}
.btn-custom{
  background-color: #ed7d31;
  color: #fff;
  border: 1px solid #ed7d31;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
}
.btn-custom:hover{
  background-color: #fff;
  color: #ed7d31;
  border: 1px solid #ed7d31;
}
</style>
